import React, { useState, useEffect } from "react";
import { Heart, Lock, Video, ChevronDown, Check, ArrowLeft } from "lucide-react";
import Confetti from "react-confetti";
import { useModelProfile } from "../context/model_profile_context";
import { useNavigate } from "react-router-dom";
import MeetTheModelComp from "./meet_the_model_comp";
import { PageNotFound } from "../../../../../core/routes/route_constants";
import { useSelector } from "react-redux";
import { AvatarGalleryImageViewerComponent } from "../component/avatar_gallery_image_viewer_comp";
export default function ChatProfileComp() {
  const navigate = useNavigate();
  const {
    activeTab,
    setActiveTab,
    purchaseCompleted,
    showNextStepModal,
    setShowNextStepModal,
    handleStartSignupFlow,
    profile,
    isAuthenticated,
    showImageViewer,
    setShowImageViewer,
    viewerImageIndex,
    setViewerImageIndex,
  } = useModelProfile();

  useEffect(() => {
    console.log("Auth Status:", isAuthenticated);
    console.log("Purchase Status:", purchaseCompleted);
  }, [isAuthenticated, purchaseCompleted]);

  // Next Step Modal Component
  const NextStepModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return <MeetTheModelComp />;
  };

  return (
    <div className="text-white overflow-y-auto h-screen">
      <div className="w-full max-w-4xl mx-auto p-4 sm:p-6 relative z-10 min-h-screen flex flex-col items-center justify-center">
        <div className="bg-slate-950/70 backdrop-blur-sm rounded-xl overflow-hidden border border-red-900/20 shadow-xl animate-fade-in w-full">
          {/* Hero Section with Profile Image and Intro */}
          <div className="flex flex-col lg:flex-row gap-1">
            {/* Left: Profile Image */}
            <div className="lg:w-5/12 relative mx-auto lg:mx-0 w-full max-w-[180px] sm:max-w-[220px] md:max-w-[260px] flex items-center justify-center lg:ml-8 mt-5 lg:mt-0">
              {/* Main profile image with glowing effect */}
              <div className="relative aspect-square w-full">
                {/* Gradient overlay for image */}
                <div
                  className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent z-10"
                  style={{ background: "transparent" }}
                ></div>

                {/* Circular frame with glow */}
                <div className="absolute inset-0 flex items-center justify-center p-2 sm:p-3 lg:p-4">
                  <div className="relative w-full aspect-square">
                    {/* Outer glow */}
                    <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-red-800 to-red-900 blur-md opacity-70"></div>
                    {/* Inner border */}
                    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-red-700 to-red-800 p-1 animate-glow">
                      {/* Image container */}
                      <div className="rounded-full overflow-hidden w-full h-full flex items-center justify-center">
                        {/* This would be an actual image in production */}
                        <div className="w-full h-full bg-slate-900 relative items-center justify-center">
                          <div className="absolute w-full h-full flex items-center justify-center">
                            <Heart size={40} className="text-pink-300 animate-pulse-soft" />
                          </div>
                          {profile.profileUrl && (
                            <div className="absolute">
                              <img src={profile.profileUrl} alt=" " className="w-full h-full rounded-md" />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Profile Intro */}
            <div className="lg:w-7/12 p-3 sm:p-4 lg:p-5 flex flex-col justify-center lg:mr-8">
              <div className="mb-3 sm:mb-4">
                <h3 className="text-sm font-light text-pink-300">Meet</h3>
                <div className="flex items-baseline">
                  <h1 className="text-xl sm:text-2xl md:text-3xl font-serif mb-2 mr-2 text-white">{profile.name || "No name available"}</h1>
                  <span className="text-sm text-pink-300">{profile.age ? `, ${profile.age}` : ""}</span>
                </div>
              </div>

              <div className="space-y-2 sm:space-y-3 mb-3 sm:mb-4">
                {profile.bio && profile.bio.length > 0 ? (
                  profile.bio.map((paragraph, index) => (
                    <p key={index} className="text-xs sm:text-sm text-pink-300">
                      {paragraph}
                    </p>
                  ))
                ) : (
                  <p className="text-xs sm:text-sm text-pink-300/50 italic">No bio available</p>
                )}
              </div>

              {/* Purchase button */}
              <div className="mt-2">
                <button
                  onClick={handleStartSignupFlow}
                  className={`w-full py-2 sm:py-3 px-3 sm:px-4 rounded-lg shadow-lg font-medium text-sm sm:text-base flex items-center justify-center active:translate-y-0.5 active:shadow-none hover:scale-105 
                      ${
                        purchaseCompleted
                          ? "bg-gradient-to-r from-green-600 to-green-700"
                          : "bg-gradient-to-r from-red-700 to-red-900 hover:opacity-90"
                      } transition-all duration-300 animate-glow`}
                >
                  <span>Chat with {profile.name}</span>
                  {!isAuthenticated && <Lock size={16} className="ml-2" />}
                </button>
                <p className="text-xs sm:text-sm text-pink-300/80 mt-1 sm:mt-2 text-center">
                  {/* {purchaseCompleted
                    ? "I'm always wet and ready"
                    : "I'll give you the release you need when we talk..."} */}
                  Call me, sext me, video chat me anytime
                </p>
              </div>
            </div>
          </div>

          {/* Tabs Navigation */}
          <div className="border-t border-b border-red-900/20 bg-slate-900/30">
            <div className="flex overflow-x-auto hide-scrollbar">
              {["Private Photos", "About Me"].map((tab) => {
                const tabKey = tab.toLowerCase().replace(/\s+/g, "");
                const mapping = {
                  privatephotos: "photos",
                  aboutme: "about",
                };
                return (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(mapping[tabKey])}
                    className={`px-4 sm:px-6 py-3 sm:py-4 transition-all duration-300 relative ${
                      activeTab === mapping[tabKey] ? "text-pink-400 font-medium" : "text-pink-300/70 hover:text-pink-300"
                    }`}
                  >
                    {tab}
                    {!purchaseCompleted && tab !== "About Me" && (
                      <span className="ml-2 inline-flex items-center justify-center">
                        {!isAuthenticated && <Lock size={12} className="text-pink-400" />}
                      </span>
                    )}
                    {activeTab === mapping[tabKey] && (
                      <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-red-800 to-red-900"></span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Tab Content */}
          <div className="p-4 sm:p-6 lg:p-8">
            {/* About Tab */}
            {activeTab === "about" && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 animate-fade-in">
                {/* Left: Details */}
                <div>
                  <h2 className="text-base font-light mb-4 sm:mb-6 text-pink-300">Details</h2>

                  <div className="space-y-4 sm:space-y-5">
                    <div className="flex border-b border-red-900/20 pb-2 sm:pb-3">
                      <span className="w-1/3 text-xs sm:text-sm text-pink-300/80">Status:</span>
                      <span className="text-xs sm:text-sm text-white flex items-center">
                        <span className="h-2 w-2 sm:h-2.5 sm:w-2.5 bg-green-500 rounded-full mr-2 animate-pulse"></span>
                        {/* {profile.status || "Status not available"} */}
                        Available
                      </span>
                    </div>
                    <div className="flex border-b border-red-900/20 pb-2 sm:pb-3">
                      <span className="w-1/3 text-xs sm:text-sm text-pink-300/80">Nickname:</span>
                      <span className="text-xs sm:text-sm text-white">{profile.nickname || "No nickname"}</span>
                    </div>
                    <div className="flex border-b border-red-900/20 pb-2 sm:pb-3">
                      <span className="w-1/3 text-xs sm:text-sm text-pink-300/80">Height:</span>
                      <span className="text-xs sm:text-sm text-white">{profile.height || "Not specified"}</span>
                    </div>
                    <div className="flex border-b border-red-900/20 pb-2 sm:pb-3">
                      <span className="w-1/3 text-xs sm:text-sm text-pink-300/80">Location:</span>
                      <span className="text-xs sm:text-sm text-white">{profile.location || "Location not set"}</span>
                    </div>
                    <div className="flex border-b border-red-900/20 pb-2 sm:pb-3">
                      <span className="w-1/3 text-xs sm:text-sm text-pink-300/80">Looking for:</span>
                      <span className="text-xs sm:text-sm text-white">{profile.lookingFor || "Not specified"}</span>
                    </div>
                  </div>
                </div>

                {/* Right: Interests & Favorites */}
                <div>
                  <div className="mb-6 sm:mb-8">
                    <h2 className="text-base font-light mb-4 text-pink-300">Interests</h2>
                    <div className="flex flex-wrap gap-2">
                      {profile.interests && profile.interests.length > 0 ? (
                        profile.interests.map((interest, index) => (
                          <span
                            key={index}
                            className="px-2 sm:px-3 py-1 sm:py-1.5 bg-slate-900/50 backdrop-blur-sm rounded-full text-xs border border-red-900/20 text-pink-200"
                          >
                            {interest}
                          </span>
                        ))
                      ) : (
                        <p className="text-xs text-pink-300/50 italic">No interests listed</p>
                      )}
                    </div>
                  </div>

                  <div>
                    <h2 className="text-base font-light mb-4 text-pink-300">Favorites</h2>
                    <div className="grid grid-cols-2 gap-3 sm:gap-4">
                      {profile.favorites ? (
                        <>
                          <div className="p-2 sm:p-3 bg-slate-900/50 backdrop-blur-sm rounded-lg border border-red-900/20">
                            <div className="text-xs text-pink-300/80 mb-1">Drink</div>
                            <div className="text-xs sm:text-sm text-white">{profile.favorites.drink || "Not specified"}</div>
                          </div>
                          <div className="p-2 sm:p-3 bg-slate-900/50 backdrop-blur-sm rounded-lg border border-red-900/20">
                            <div className="text-xs text-pink-300/80 mb-1">Movie</div>
                            <div className="text-xs sm:text-sm text-white">{profile.favorites.movie || "Not specified"}</div>
                          </div>
                        </>
                      ) : (
                        <p className="text-xs text-pink-300/50 italic col-span-2">No favorites listed</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Photos Tab */}
            {activeTab === "photos" && (
              <div className="animate-fade-in">
                <div className="flex justify-between items-center mb-4 sm:mb-6">
                  <h2 className="text-base font-light text-pink-300">My Private Collection</h2>
                  <div className="px-2 sm:px-3 py-1 bg-gradient-to-r from-red-800 to-red-900 rounded-full text-xs font-medium">18+ Content</div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
                  {profile.mediaItems && profile.mediaItems.length > 0 ? (
                    profile.mediaItems.map((data, imageIndex) => (
                      
                      <div
                        key={imageIndex}
                        onClick={() => {
                          if (data.isBlur && (!isAuthenticated || (isAuthenticated && !purchaseCompleted))) {
                            handleStartSignupFlow();
                          } else {
                            setViewerImageIndex(imageIndex);
                            setShowImageViewer(true);
                          }
                        }}
                        className="aspect-square bg-slate-900/50 backdrop-blur-sm rounded-lg overflow-hidden border border-red-900/20 relative group cursor-pointer"
                        style={{ animationDelay: `${imageIndex * 0.1}s` }}
                      >
                        {console.log(data)}
                        {/* Lock overlay - only show if isBlur is true */}
                        {data.isBlur && (!isAuthenticated || (isAuthenticated && !purchaseCompleted)) && (
                          <div
                            data-purchaseCompleted={purchaseCompleted}
                            className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm flex flex-col items-center justify-center z-20 group-hover:bg-slate-950/40 transition-all duration-300"
                          >
                            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-r from-red-800 to-red-900 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-300 animate-glow">
                              <Lock size={16} className="text-white" />
                            </div>
                            <div className="bg-gradient-to-r from-red-800 to-red-900 rounded-full px-2 sm:px-3 py-1 text-xs font-medium animate-pulse-soft">
                              Exclusive
                            </div>
                          </div>
                        )}

                        {/* Image hover overlay */}
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 flex items-end p-2 sm:p-3">
                          <span className="text-white text-xs">Just for you</span>
                        </div>

                        <div className="w-full h-full bg-gradient-to-br from-slate-900/50 to-fuchsia-950/50">
                          <img src={data.fileUrl} alt={`Private content ${imageIndex}`} className="w-full h-full object-cover" />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-span-2 sm:col-span-3 flex flex-col items-center justify-center p-6 sm:p-8 bg-slate-900/50 backdrop-blur-sm rounded-lg border border-red-900/20">
                      <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-r from-red-800 to-red-900 flex items-center justify-center mb-3 sm:mb-4">
                        <Video size={20} className="text-white" />
                      </div>
                      <p className="text-xs text-pink-300/50 italic text-center">No private photos available yet</p>
                      <p className="text-xs text-pink-300/30 mt-2 text-center">Check back later for exclusive content</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="md:h-[3rem] h-[6rem]"></div>
      </div>

      {/* Next Step Modal */}
      <NextStepModal isOpen={showNextStepModal} onClose={() => setShowNextStepModal(false)} />

      {/* Avatar Gallery Image Viewer */}
      <AvatarGalleryImageViewerComponent
        mediaItems={profile.mediaItems}
        showImageViewer={showImageViewer}
        viewerImageIndex={viewerImageIndex}
        onClose={() => setShowImageViewer(false)}
        onIndexChange={(index) => setViewerImageIndex(index)}
      />
    </div>
  );
}
